/**
 * Registry of sideload extension manifest names to their base URLs.
 * Used to resolve extension assets (e.g. iframes) to the correct origin after sideload.
 */
const registry = new Map<string, string>();

export function setSideloadBaseUrl(
  manifestName: string,
  baseUrl: string,
): void {
  registry.set(manifestName, baseUrl);
}

export function getSideloadBaseUrl(manifestName: string): string | undefined {
  return registry.get(manifestName);
}

export function getAllSideloadBaseUrls(): Map<string, string> {
  return new Map(registry);
}
